import * as React from 'react';

interface IDemoLinkGeneratorProps {
}

interface IDemoLinkGeneratorState {
    contactId: number;
    loaded: boolean;
    error?: string;
    contactName: string;
    complete: boolean;
    products?: IProduct[];
    generatedLink?: string;
}

interface IProduct {
    productId: number;
    productTitle: string;
    productCulture: string;
    productStatus: string;
    productType: string;
    productIsbn: string;
}

interface IUIData {
    contactName: string;
    error: string;
    products?: IProduct[];
}

interface IGeneratedLinkResponse {
    linkURL: string;
    error: string;
}

export default class DemoLinkGenerator extends React.PureComponent<IDemoLinkGeneratorProps, IDemoLinkGeneratorState> {
    _productsDiv?: HTMLDivElement | null;
    _linkInput?: HTMLInputElement | null;

    constructor(props: IDemoLinkGeneratorProps) {
        super(props);
        this.state = { contactId: parseInt(new URLSearchParams(window.location.search).get("hs_object_id") || ""), loaded: false, contactName: "", complete: false };
    }

    copyLink() {
        this._linkInput?.select();
        document.execCommand("copy");
        this.closeForm();
    }
    cancelForm() {
        window.parent.postMessage(JSON.stringify({ "action": "CANCEL" }), "*");
    }

    closeForm() {
        window.parent.postMessage(JSON.stringify({ "action": "DONE" }), "*");
    }

    async createNewClick() {
        let productIds = "";
        if (this._productsDiv != null) {
            let inputs = this._productsDiv.getElementsByTagName("input");
            for (var i = 0; i < inputs.length; i++) {
                if (inputs[i].checked)
                    productIds += inputs[i].getAttribute("data-productid") + ";";
            }
        }
        const response = await fetch("/api/demolink/generatelink", {
            method: "POST",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify(
                {
                    "contactId": this.state.contactId,
                    "productIds": productIds.replace(/;$/, "")
                })
        });
        const data = await response.json() as IGeneratedLinkResponse;
        this.setState({ complete: data.error == null, generatedLink: data.linkURL, error: data.error });
    }

    async componentDidMount() {
        const response = await fetch(`/api/demolink/uidata?contactId=${this.state.contactId}`);
        const data = await response.json() as IUIData;
        this.setState({ loaded: true, contactName: data.contactName, error: data.error, products: data.products });
    }

    render() {
        return <>
            {this.state.loaded &&
                <div id="BodyContent">
                    {this.state.error != null && < div className="alert alert-danger text-center" id="cAlert">
                        <label id="lblError">{this.state.error}</label>
                    </div>}
                    {!this.state.complete &&
                        <div className="container" id="cSelect">
                            <p>Select the products to include in a demo link for <strong><label id="hsContact">{this.state.contactName}</label></strong>. This link will allow the customer to have 7 days of access, which begins after they click on the link.</p>
                            <div className="card">
                                <div className="card-body list-group bg-light p-4" id="dProducts" ref={(val) => this._productsDiv = val}>
                                    {this.state.products?.map((p: IProduct, idx: number) => {
                                        return <div key={idx} className="custom-control custom-checkbox">
                                            <input id={`cbx${idx}`} type="checkbox" className="custom-control-input" data-productid={p.productId} />
                                            <label className="custom-control-label" htmlFor={`cbx${idx}`} />{`${p.productTitle} (${p.productIsbn})`}
                                        </div>;
                                    })}
                                </div>
                            </div>
                            <div className="container mt-2">
                                <button type="button" className="float-right btn btn-secondary ml-2" onClick={() => { this.cancelForm() }}>Cancel</button>
                                <button type="submit" className="float-right btn btn-primary" id="btnCreateLink" onClick={() => { this.createNewClick() }}>Create Demo Link</button>
                            </div>
                        </div>
                    }
                    {this.state.complete && <div className="container" id="cComplete">
                        <div className="alert alert-success" role="alert">
                            <div><input type="text" readOnly={true} className="w-100" value={this.state.generatedLink} ref={(value) => this._linkInput = value} /></div>
                            <div style={{ "height": "37px", "margin": "17px 0px 0px 0px" }}><button type="submit" className="float-right btn btn-primary" onClick={() => { this.copyLink() }}>Copy Link</button></div>
                        </div>
                    </div>}
                </div>
            }
        </>;
    }
}